import * as React from 'react';
import { TProductCard } from './ProductCard.types';
import { IconButton } from 'components';
import { Visibility, Favorite, CompareArrows } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { createIdLinkFromTemplate } from '../../../utils/navigation';
import { APP_ROUTES } from '../../../constants/routes';
import './ProductCard.styled.scss';
import { calculateDiscountPercentage } from 'utils/product';
import { useAppSelector } from 'store/store';
import { TPhoneTag } from 'api/phoneCases/phoneCases.types';

export const ProductCard: TProductCard = ({ productData, localize }) => {
  const navigate = useNavigate();
  const {
    tagsList: { data: tagsList },
  } = useAppSelector((store) => store.tags);

  const discountPercentage = productData.newPrice
    ? calculateDiscountPercentage(productData.price, productData.newPrice)
    : null;

  const handleProductClick = () => {
    navigate(
      createIdLinkFromTemplate(
        APP_ROUTES.PHONE_CASE_PRODUCT,
        productData.id,
        localize
      )
    );
  };

  const handleFavorite = (e: React.MouseEvent) => {
    e.stopPropagation();
    // Favorite logic here
  };

  const handleCompare = (e: React.MouseEvent) => {
    e.stopPropagation();
    // Compare logic here
  };

  const handleQuickView = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleProductClick();
  };

  const productTags: TPhoneTag[] = React.useMemo(() => {
    return (
      productData.tags.map((tag) =>
        tagsList?.items?.find((t) => t.id === tag)
      ) || []
    );
  }, [productData.tags, tagsList]);

  return (
    <div className="product-card" onClick={handleProductClick}>
      <div className="product-card__image-section">
        <div className="product-card__image-container">
          <img
            src={productData?.images?.[0]}
            alt={productData.name}
            className="product-card__image"
          />
          <div className="product-card__actions">
            <IconButton
              className="product-card__action-btn"
              onClick={handleQuickView}
              size="small"
            >
              <Visibility />
            </IconButton>
            <IconButton
              className="product-card__action-btn"
              onClick={handleFavorite}
              size="small"
            >
              <Favorite />
            </IconButton>
            <IconButton
              className="product-card__action-btn"
              onClick={handleCompare}
              size="small"
            >
              <CompareArrows />
            </IconButton>
          </div>
        </div>
      </div>
      <div className="product-card__content">
        <div className="product-card__badges">
          {!!productData.newPrice && (
            <span className="product-card__badge product-card__badge--discount">
              -{discountPercentage}%
            </span>
          )}
          {productTags.map((tag) => (
            <span
              key={tag?.id}
              className="product-card__badge product-card__badge--tag"
              style={{ backgroundColor: tag?.color }}
            >
              {localize(tag?.name)}
            </span>
          ))}
        </div>
        <h3 className="product-card__title">{localize(productData.name)}</h3>
        <p className="product-card__description">
          {localize(productData.description)}
        </p>
        <div className="product-card__price-section">
          {!!productData.newPrice && (
            <span className="product-card__price product-card__price--old">
              {productData.price} zl.
            </span>
          )}
          <span className="product-card__price product-card__price--current">
            {productData.newPrice || productData.price} zl.
          </span>
        </div>
      </div>
    </div>
  );
};
